import App from './App.svelte';
import { parse } from "qs";
import Cookies from 'js-cookie';
const parsed = parse(window.location.search);
const dft = Cookies.get('dft');
const app = new App({
	target: document.body,
	props: {
		dftCookie: dft,
		dftUrl: parsed['?token']
	}
});

export default app;